import chatModule from '../chatModule';

const notificationsName = {
  ChatNotifications: 'ChatNotifications',
  FriendshipNotifications: 'FriendshipNotifications',
  PresenceNotifications: 'PresenceNotifications',
  ChatPrivacySettingNotifications: 'ChatPrivacySettingNotifications',
  PresenceBulkNotifications: 'PresenceBulkNotifications',
  VoiceNotifications: 'VoiceNotifications'
};

chatModule.constant('notificationsName', notificationsName);

export default notificationsName;
